import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Marco B.",
    role: "Villa privata, Seveso (MB)",
    rating: 5,
    text: "Ho installato un impianto da 8 kWp con accumulo. Squadra puntualissima, tetto rimasto pulito come prima e tutta la burocrazia gestita da loro. In bolletta ho già visto la differenza dal secondo mese.",
  },
  {
    name: "Studio Tecnico R&P",
    role: "Capannone industriale, Meda (MB)",
    rating: 5,
    text: "Ci siamo affidati per un impianto da 120 kWp sul tetto del capannone. Sopralluogo serio, progetto presentato in 48 ore, installazione in tempi rispettati. Continuano a seguire la manutenzione: clienti soddisfatti.",
  },
  {
    name: "Famiglia Colombo",
    role: "Lavaggio pannelli, Cesano Maderno",
    rating: 5,
    text: "Il nostro impianto rendeva meno del previsto. Dopo il lavaggio professionale la produzione è tornata sui valori del primo anno. Personale gentile, attrezzatura impeccabile, prezzo onesto.",
  },
  {
    name: "Andrea M.",
    role: "Manutenzione impianto esistente",
    rating: 5,
    text: "Inverter in blocco, mi avevano dato preventivi assurdi altrove. Lici è venuto, diagnosticato e risolto in mezza giornata. Da allora ho il contratto di manutenzione annuale: dormo tranquillo.",
  },
  {
    name: "Ing. Sara V.",
    role: "Villa di pregio, Lago di Como",
    rating: 5,
    text: "Cercavo un'azienda che curasse l'estetica oltre alla resa. Pannelli integrati perfettamente nel tetto in cotto, zero impatto visivo. Eleganza e competenza tecnica nello stesso pacchetto.",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="section-testimonials"
      className="py-20 md:py-28 bg-[#FAFAFA] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="accent-line" />
            <span className="text-xs uppercase tracking-[0.25em] text-[#D97706] font-medium">
              Cosa Dicono di Noi
            </span>
          </div>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#0F5132] leading-tight">
            La fiducia di chi ci ha scelto.
          </h2>
          <p className="mt-5 text-[#4B5563]">
            Oltre 500 impianti realizzati. Ecco alcune voci di clienti privati e aziende.
          </p>
        </div>

        {/* Marquee / horizontal scroll */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.slice(0, 3).map((t, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative p-7 rounded-2xl bg-white border border-[#E5E7EB] hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <Quote className="absolute -top-3 -left-2 h-10 w-10 text-[#D97706]/20" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="h-4 w-4 fill-[#D97706] text-[#D97706]" />
                ))}
              </div>
              <p className="text-[#111827] leading-relaxed text-[15px]">"{t.text}"</p>
              <div className="mt-6 pt-5 border-t border-[#E5E7EB]">
                <div className="font-serif text-lg text-[#0F5132]">{t.name}</div>
                <div className="text-xs uppercase tracking-widest text-[#4B5563] mt-1">
                  {t.role}
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Second row offset */}
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.slice(3).map((t, i) => (
            <article
              key={i + 3}
              data-testid={`testimonial-${i + 3}`}
              className="relative p-7 rounded-2xl bg-[#0F5132] text-white border border-[#0F5132] hover:shadow-xl transition-all duration-300"
            >
              <Quote className="absolute -top-3 -left-2 h-10 w-10 text-[#FED7AA]/30" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, k) => (
                  <Star key={k} className="h-4 w-4 fill-[#FED7AA] text-[#FED7AA]" />
                ))}
              </div>
              <p className="text-white/95 leading-relaxed text-[15px]">"{t.text}"</p>
              <div className="mt-6 pt-5 border-t border-white/15">
                <div className="font-serif text-lg text-[#FED7AA]">{t.name}</div>
                <div className="text-xs uppercase tracking-widest text-white/70 mt-1">
                  {t.role}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
